import { Product } from "../types";
import { protectV1EN } from "./protect-v1.en";
import { protectV1NL } from "./protect-v1.nl";
import { protectV2EN } from "./protect-v2.en";
import { protectV2NL } from "./protect-v2.nl";

/** Set `image` to a path under /images to replace the placeholder on a product button. */
export const products: Product[] = [
	{
		id: "PRO-TW1-ORG",
		name: "Protect (MyEarsOnly)",
		image: "/images/faq/product-protect-v1.jpg",
		tagline: { EN: "Earbuds with the MyEarsOnly app.", NL: "Earbuds met de MyEarsOnly app." },
		faq: { EN: protectV1EN, NL: protectV1NL },
	},
	{
		id: "PRO-TW2-ORG",
		name: "Protect (myProtect)",
		image: "/images/faq/product-protect-v2.jpg",
		tagline: { EN: "Earbuds with the myProtect app.", NL: "Earbuds met de myProtect app." },
		faq: { EN: protectV2EN, NL: protectV2NL },
	},
];
